<template>
    <div class="door-check-add">
        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">
                    <h2 class="page-header-title">
                        <router-link to="/fire-stopping-reports">
                        Fire Stopping Reports</router-link>
                        &raquo;
                        <span v-if="isEdit">
                        <router-link :to="{ name: 'fire-stopping-report-view', params: {action: 'view', id: fireStoppingReport.site_fire_stopping_report_id} }">
                            {{ fireStoppingReport.job_number }} | {{ fireStoppingReport.prepared_for }}
                        </router-link>
                             &raquo;
                            </span>
                        <span v-if="isEdit">
                                  Edit Fire Stopping Report</span><span v-else>  Add Fire Stopping Report</span></h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <input
                        name="site_fire_stopping_report_id"
                        type="hidden"
                        v-model="fireStoppingReport.site_fire_stopping_report_id"
                >
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">

                    <div class="row">
                        <div class="col-sm-12 widget-20">
                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Report Details</h2>
                                </div>
                                <div class="widget-body">
                                    <div class="form-group row d-flex align-items-center required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('sequential_reference_number')]"
                                               for="sequential_reference_number">Sequential Reference Number</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="sequential_reference_number"
                                                    :class="['form-control', getFieldClasses('sequential_reference_number')]"
                                                    maxlength="255"
                                                    id="sequential_reference_number"
                                                    v-model="fireStoppingReport.sequential_reference_number"
                                                    @blur="onFieldBlur('sequential_reference_number')"
                                            />
                                            <div v-if="isErrorField('sequential_reference_number')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('job_number')]"
                                               for="job_number">Job Number</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="job_number"
                                                    :class="['form-control', getFieldClasses('job_number')]"
                                                    maxlength="255"
                                                    id="job_number"
                                                    v-model="fireStoppingReport.job_number"
                                                    @blur="onFieldBlur('job_number')"
                                            />
                                            <div v-if="isErrorField('job_number')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('prepared_for')]"
                                                for="prepared_for">Prepared for</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="prepared_for"
                                                    :class="['form-control', getFieldClasses('prepared_for')]"
                                                    maxlength="255"
                                                    id="prepared_for"
                                                    v-model="fireStoppingReport.prepared_for"
                                                    @blur="onFieldBlur('prepared_for')"
                                            />
                                            <div v-if="isErrorField('prepared_for')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center  required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('site_address')]"
                                               for="client-site">Site Address</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="site_address"
                                                    :class="['form-control', getFieldClasses('site_address')]"
                                                    v-model="fireStoppingReport.site_address"
                                                    id="site_address"
                                                    @blur="onFieldBlur('site_address')"
                                            /></div>
                                        <div v-if="isErrorField('site_address')" class="invalid-feedback">This field is required</div>
                                    </div>
                                    
                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="date-of-inspection">
                                            Date Of Inspection
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <datepicker
                                                    v-model="fireStoppingReport.date_of_inspection"
                                                    format="dd/MM/yy"
                                                    input-class="form-control"
                                                    name="date_of_inspection"
                                            ></datepicker>
                                        </div>
                                    </div>

                                    <div class="form-group row align-items-center d-flex">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            Sign-off Signature
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="signature-area" v-if="fireStoppingReport.offline_sign_off_signature_image != null">
                                                <img v-bind:src="fireStoppingReport.offline_sign_off_signature_image.data" class="img-fluid">
                                            </div>
                                            <div v-else-if="fireStoppingReport.sign_off_signature_image != null">
                                                Signature uploaded
                                            </div>
                                            <div class="pt-2">
                                                <div v-if="addingSignOffSignature">
                                                    <div class="signature-area">
                                                        <VueSignaturePad width="100%" height="200px" ref="signOffSignaturePad" />
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="saveSignOffSignature">Save signature</a>
                                                        </div>
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="clearSignOffSignature">Clear signature</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                    href="javascript:void(0)"
                                                    v-on:click="addEditSignOffSignature"
                                                ><span v-if="fireStoppingReport.offline_sign_off_signature_image != null || fireStoppingReport.sign_off_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>

    </div>
</template>

<style>
    .form-control {
        background: #fff !important;
    }
    .vdp-datepicker__calendar .selected {
        background: var(--primary-color) !important;
        color: #fff;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--primary-color) !important;
    }
</style>

<script>
    import { required } from 'vuelidate/lib/validators'

    import moment from 'moment'
    import Datepicker from 'vuejs-datepicker';

    export default {
        data() {
            return {
                isEdit: false,
                addingSignOffSignature: false,
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                fireStoppingReport: {
                    site_fire_stopping_report_id: Math.floor(new Date().getTime() / 1000),
                    fire_stopping_report_id: null,
                    sequential_reference_number: null,
                    job_number: null,
                    date_of_inspection: new Date(),
                    prepared_for: null,
                    site_address: null,
                    sign_off_signature_image: null,
                    pdf_link: null,
                    report_version: null,
                    offline_sign_off_signature_image: null
                }
            }
        },
        validations: {
            fireStoppingReport: {
                sequential_reference_number: { required },
                job_number: { required },
                prepared_for: { required },
                site_address: { required },
            },
        },
        methods: {
            getFireStoppingReport() {
                var vmt = this;
                this.getDb(function onConnected(db) {

                    var vm = vmt;
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('fire_stopping_reports').objectStore('fire_stopping_reports');
                        var storeRequest = objectStore.get(reportId);

                        storeRequest.onsuccess = function(event) {
                            if(storeRequest.result.offline_sign_off_signature_image === undefined) {
                                storeRequest.result.offline_sign_off_signature_image = null;
                            }
                            if(storeRequest.result.sign_off_signature_image === undefined) {
                                storeRequest.result.sign_off_signature_image = null;
                            }
                            vm.fireStoppingReport = storeRequest.result;
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            clearSignOffSignature() {
                this.$refs.signOffSignaturePad.clearSignature();
            },
            saveSignOffSignature() {
                const { isEmpty, data } = this.$refs.signOffSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.fireStoppingReport.offline_sign_off_signature_image = {
                        data: data
                    };
                }
                
                this.addingSignOffSignature = false;
                this.clearSignOffSignature();
            },
            addEditSignOffSignature() {
                this.addingSignOffSignature = true;
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                var vm = this
                let request = new Promise((resolve, reject) => {
                    vm.getDb(function onConnectedGetDoorSets(db) {
                        var putRequest = db.transaction('fire_stopping_reports', 'readwrite')
                            .objectStore('fire_stopping_reports').put({
                                site_fire_stopping_report_id: vm.fireStoppingReport.site_fire_stopping_report_id,
                                fire_stopping_report_id: vm.fireStoppingReport.fire_stopping_report_id,
                                sequential_reference_number: vm.fireStoppingReport.sequential_reference_number,
                                job_number: vm.fireStoppingReport.job_number,
                                date_of_inspection: vm.fireStoppingReport.date_of_inspection,
                                prepared_for: vm.fireStoppingReport.prepared_for,
                                site_address: vm.fireStoppingReport.site_address,
                                sign_off_signature_image: vm.fireStoppingReport.sign_off_signature_image,
                                pdf_link: vm.fireStoppingReport.pdf_link,
                                report_version: typeof vm.fireStoppingReport.report_version == 'undefined' ? null : vm.fireStoppingReport.report_version,
                                offline_sign_off_signature_image: vm.fireStoppingReport.offline_sign_off_signature_image,
                            });
                        putRequest.onsuccess = function(event) {
                            vm.submitSuccess({
                                success: true,
                                fire_stopping_report_id: putRequest.result,
                            })
                        }
                        putRequest.onerror = function(event) {
                            alert("Unable to add data ");
                        }

                    })
                });
            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'fire-stopping-report-view', params: {action: 'view', id: response.fire_stopping_report_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.fireStoppingReport)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.fireStoppingReport[field]) {
                    return this.$v.fireStoppingReport[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            reload() {
                window.location = '';
            },
        },
        components: {
            Datepicker,
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FSR') === -1) {
                this.$router.push('/');
                return;
            }

            let reportId = this.$route.params.id;
            if (reportId) {
                this.isEdit = true;
                this.getFireStoppingReport();
            }
        },

    }
</script>